import {
  recognizeFlow,
  recognizeFlowVersion,
} from "@redotech/redo-recognize-actions-common/actions-flow";
import * as z from "zod";

export const getRecognizeActions = {
  name: "getRecognizeActions" as const,
  input: z.null(),
  output: z.object({
    activeVersionId: z.string().nullable(),
    versions: z.array(recognizeFlowVersion),
  }),
};

export const saveRecognizeActions = {
  name: "saveRecognizeActions" as const,
  input: z.object({
    expectedVersionId: z.string().nullable(),
    steps: recognizeFlow,
  }),
  output: z.discriminatedUnion("saved", [
    z.object({ saved: z.literal(false) }),
    z.object({ saved: z.literal(true), version: recognizeFlowVersion }),
  ]),
};
